export const PlaceholderRow = styled.tr`
	&:hover {
		background-color: inherit !important;
	}
`;
export const StyledCenterHeaderCell = styled.th`
	padding: 16px 24px;
	text-align: center;
	font-weight: 400;
	color: #565758ff;
	font-size: 13px;
	line-height: 20px;
	letter-spacing: 0.01em;
	border-bottom: 1px solid #e2e8f0;
	width: calc(100% / 6);
	background-color: #f7fafc;
`;
export const StyledTableHeaderCell = styled.th`
	padding: 16px 24px;
	text-align: left;
	font-weight: 400;
	color: #565758ff;
	font-size: 13px;
	line-height: 20px;
	letter-spacing: 0.01em;
	border-bottom: 1px solid #e2e8f0;
	width: calc(100% / 6);
	background-color: #f7fafc;
`;
export const StyledTableCell = styled.td`
	padding: 16px 24px;
	color: #1f2937;
	font-weight: 400;
	font-size: 14px;
	line-height: 18px;
	font-weight: 500;
	vertical-align: middle;
`;
import styled from "styled-components";

export const EmailSchedulerContainer = styled.div`
  width: 80%;
  margin: 24px auto 0;
  padding: 32px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  position: relative; /* enable absolute children like overlay banner */
  min-height: calc(100vh - 220px); /* go almost to the end of the page, but not full */

  /* Avoid overflow on shorter viewports */
  @media (max-height: 800px) {
    min-height: unset;
  }

  @media (max-width: 768px) {
    width: 90%;
    padding: 20px;
  }
`;



export const HeaderSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

export const PageTitle = styled.h1`
  font-size: 28px;
  font-weight: 600;
  color: #2d3748;
  margin: 0;
`;



export const InfoBanner = styled.div`
  background: linear-gradient(135deg, #f0fff4 0%, #e6fffa 100%);
  border: 1px solid #c6f6d5;
  border-radius: 8px;
  padding: 16px 20px;
  margin-bottom: 32px;
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const InfoIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const InfoText = styled.div`
  color: #2d3748;
  font-size: 14px;
  line-height: 1.5;
  margin: 0;
`;

export const TableContainer = styled.div`
	background: white;
	border-radius: 8px;
	/* border: 1px solid #e2e8f0; */
	overflow: visible; /* allow dropdowns/menus to overflow */
	display: block;
	min-height: 340px;
	height: 100%;
`;

export const StyledTable = styled.table`
	width: 100%;
	border-collapse: collapse;
	table-layout: fixed; /* equalize column widths */

	/* Make the last column (actions) narrow */
	th:last-child,
	td:last-child {
		width: 40px;
	}

	/* Hide less important columns on narrow screens */
	@media (max-width: 900px) {
		th:nth-child(2), /* Profile */
		td:nth-child(2),
		th:nth-child(4), /* Recurrency */
		td:nth-child(4) {
			display: none;
		}
	}

	@media (max-width: 700px) {
		th:nth-child(3), /* Report */
		td:nth-child(3) {
			display: none;
		}
	}

	@media (max-width: 600px) {
		th:nth-child(5), /* Status */
		td:nth-child(5) {
			display: none;
		}
	}
`;

export const TableHeader = styled.thead`
	background-color: #f7fafc;
`;

export const TableHeaderCell = styled.th`
	padding: 16px 24px;
	text-align: left;
	font-weight: 600;
	color: #334155;
	font-size: 13px;
	line-height: 20px;
	letter-spacing: 0.01em;
	border-bottom: 1px solid #e2e8f0;
	width: calc(100% / 6);

	@media (max-width: 1024px) {
		padding: 12px 16px;
		font-size: 12px;
	}
	@media (max-width: 600px) {
		padding: 10px 12px;
		font-size: 11px;
	}
	@media (max-width: 480px) {
		padding: 8px 10px;
		font-size: 10px;
	}
`;

export const CenterHeaderCell = styled.th`
	padding: 16px 24px;
	text-align: center;
	font-weight: 600;
	color: #334155;
	font-size: 13px;
	line-height: 20px;
	letter-spacing: 0.01em;
	border-bottom: 1px solid #e2e8f0;
	width: calc(100% / 6);

	@media (max-width: 1024px) {
		padding: 12px 16px;
		font-size: 12px;
	}
	@media (max-width: 600px) {
		padding: 10px 12px;
		font-size: 11px;
	}
	@media (max-width: 480px) {
		padding: 8px 10px;
		font-size: 10px;
	}
`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr`
	border-bottom: 1px solid #f1f5f9;
	height: 30px; /* must match pagination row height assumption */
	
	&:hover {
		background-color: #f8fafc;
	}
	
	&:last-child {
		border-bottom: none;
	}
`;

export const TableCell = styled.td`
	padding: 6px 24px; /* match header left padding for alignment */
	color: #1f2937;
	font-size: 14px;
	line-height: 18px;
	font-weight: 500;
	vertical-align: middle;
	letter-spacing: 0.005em;
	width: calc(100% / 6);
	overflow: hidden;

	@media (max-width: 1024px) {
		padding: 6px 10px;
		font-size: 14px;
	}
	@media (max-width: 600px) {
		padding: 6px 8px;
		font-size: 13px;
	}
	@media (max-width: 480px) {
		padding: 6px 6px;
		font-size: 12px;
	}
`;

export const TruncatedText = styled.span`
	display: inline-block;
	max-width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	cursor: help;
`;

export const ActionCell = styled.td`
	padding: 0 6px 0 0; /* reduce left padding to tighten space */
	text-align: right;
	width: 40px;
	white-space: nowrap;
`;

export const StatusCell = styled.td`
	padding: 16px 0; /* no horizontal padding so icon centers under header */
	vertical-align: middle;
	text-align: center;
`;

export const StatusIcon = styled.div<{ isActive: boolean }>`
	width: 20px;
	height: 20px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${props => props.isActive ? '#38a169' : '#a0aec0'};
	color: white;
	font-size: 12px;
`;

export const ActionMenu = styled.div`
	position: relative;
	display: inline-block;
`;

export const ActionButton = styled.button`
	background: none;
	border: none;
	cursor: pointer;
	padding: 4px;
	border-radius: 4px;
	color: #718096;
	font-size: 18px;
	line-height: 1;
	
	&:hover {
		background-color: #f7fafc;
		color: #4a5568;
	}
`;

export const ActionDropdown = styled.div<{ $isOpen: boolean }>`
	position: absolute;
	top: 100%;
	right: 0;
	background: white;
	border: 1px solid #e2e8f0;
	border-radius: 6px;
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
	z-index: 1000;
	min-width: 120px;
	display: ${props => props.$isOpen ? 'block' : 'none'};
`;

export const ActionItem = styled.button<{ $isDelete?: boolean }>`
	width: 100%;
	padding: 8px 16px;
	text-align: left;
	background: none;
	border: none;
	cursor: pointer;
	font-size: 14px;
	color: ${props => props.$isDelete ? '#e53e3e' : '#4a5568'};
	
	&:hover {
		background-color: #f7fafc;
	}
	
	&:first-child {
		border-radius: 6px 6px 0 0;
	}
	
	&:last-child {
		border-radius: 0 0 6px 6px;
	}
`;

export const PaginationSection = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-top: auto; /* push to bottom */
	padding: 16px 0;
	border-top: 1px solid #e2e8f0; /* separator from table */
	flex-shrink: 0; /* stay at the bottom */

	@media (max-width: 600px) {
		flex-direction: column;
		gap: 8px;
	}
`;

export const ItemCount = styled.span`
	color: #718096;
	font-size: 14px;
`;

export const PaginationControls = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
`;

export const PaginationButton = styled.button<{ disabled?: boolean }>`
	background: none;
	border: none;
	padding: 8px 12px;
	border-radius: 4px;
	cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
	color: ${props => props.disabled ? '#cbd5e0' : '#718096'};
	
	&:hover:not(:disabled) {
		background-color: #f7fafc;
		color: #4a5568;
	}
`;

export const PageInfo = styled.span`
	color: #718096;
	font-size: 14px;
	margin: 0 16px;
`;

export const Tooltip = styled.div<{ $isVisible: boolean }>`
	position: fixed; /* follow cursor regardless of scroll */
	background: #2d3748;
	color: white;
	padding: 8px 12px;
	border-radius: 6px;
	font-size: 12px;
	line-height: 1.4;
	max-width: 250px;
	z-index: 1001;
	display: ${props => props.$isVisible ? 'block' : 'none'};
	pointer-events: none; /* do not capture hover to avoid blinking */
	
	&::after {
		content: '';
		position: absolute;
		top: 12px; /* roughly middle vertically */
		left: -6px;
		width: 0;
		height: 0;
		border-top: 6px solid transparent;
		border-bottom: 6px solid transparent;
		border-right: 6px solid #2d3748; /* left pointing arrow */
	}
`;

// Empty state styles
export const EmptyState = styled.div`
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;  
		text-align: center;
		gap: 12px;
		min-height: 400px;
		max-width: 600px;
		width: 100%;
		box-sizing: border-box;
		overflow-wrap: break-word;
		word-break: break-word;
		margin: 0 auto;
		/* Prevent background color change on hover */
		&:hover {
			background: none !important;
		}
		@media (max-width: 900px) {
			padding: 18px 16px;
			max-width: 90vw;
		}
		@media (max-width: 600px) {
			padding: 12px 8px;
			font-size: 13px;
			max-width: 98vw;
		}
		@media (max-width: 480px) {
			padding: 8px 4px;
			font-size: 12px;
			max-width: 100vw;
		}
`;

export const EmptyStateImage = styled.img`
  width: 180px;
  height: auto;
  opacity: 0.95;
`;

export const EmptyStateTitle = styled.div`
  font-weight: 600;
  color: #1f2937;
`;

export const EmptyStateDescription = styled.div`
  color: #4b5563;
  max-width: 420px;
  font-size: 14px;
`;

// Minimal lock glyph (not an icon), built with CSS
export const LockGlyph = styled.div`
  position: relative;
  width: 16px;
  height: 12px;
  border-radius: 3px;
  background: #cbd5e1; /* neutral-30 */
  display: inline-block;

  &::before {
    content: '';
    position: absolute;
    left: 2px;
    right: 2px;
    top: -7px;
    height: 8px;
    border: 2px solid #cbd5e1;
    border-bottom: none;
    border-radius: 8px 8px 0 0;
  }
`; 